<div class="stick-top">
  <mat-toolbar><mat-icon>extension</mat-icon> OS Version</mat-toolbar>
  <div class="hbox lightly-padded button-bar">
    <button mat-raised-button class="primary" routerLink="/osVersions/0">
      <mat-icon aria-label="Create a new OS version">add</mat-icon>
      Create a new OS Version
    </button>
  </div>
</div>

<div class="padded">
  <table class="basicTable">
    <thead>
      <tr>
        <th *ngIf="auth.isCompanyAdmin()" style="width: 75px;">
          <div class="vbox">
            Company
            <micro-company-select [(companyId)]="filter.companyId" ></micro-company-select>
          </div>
        </th>
        <th>
          <div class="vbox">OS<input [(ngModel)]="filter.osFamily" /></div>
        </th>
        <th>
          <div class="vbox">Version<input [(ngModel)]="filter.name" /></div>
        </th>
        <th>
          <div class="vbox">
            Description<input [(ngModel)]="filter.description" />
          </div>
        </th>
        <th>
          <div class="vbox">Active<input [(ngModel)]="filter.active" /></div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let element of dataSource.data">
        <td *ngIf="auth.isCompanyAdmin()"><micro-company-lookup [companyId]="element.companyId"></micro-company-lookup></td>
        <td>
          <a routerLink="/os/{{ element.osFamilyId }}">{{osFamilyNames.get(element.osFamilyId) || element.osFamilyId}}</a></td>
        <td>
          <a routerLink="/osVersions/{{ element.id }}">{{ element.name }}</a>
        </td>
        <td>{{ element.description }}</td>
        <td>{{ element.active }}</td>
      </tr>
      <tr *ngIf="dataSource.data?.length === 0">
        <td colspan="100"><em>No results found</em></td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td colspan="100">
          <mat-paginator
            #paginator
            (page)="reload()"
          ></mat-paginator>
        </td>
      </tr>
    </tfoot>
  </table>
</div>
